import t from "@constants/localization";

const RETURN_PATH = "screens/MyDeliveries/DeliveryReturnsList";

function findAmountWithPriority(priorityArray, amountObj) {
  let amount = 0;
  let keyI = "cashToClGullak";
  for (let i = 0; i < priorityArray.length; i++) {
    const key = priorityArray[i];
    // eslint-disable-next-line no-prototype-builtins
    if (amountObj.hasOwnProperty(key) && amountObj[key] > 0) {
      amount = amountObj[key];
      keyI = key;
      break;
    }
  }
  return {
    amount,
    keyI,
  };
}

export const getReturnAmount = (amountObj = {}) => {
  const priorityArray = [
    "cashRefundedToClGullak",
    "cashToClGullak",
    "cashToCustomer",
    "cashRefundedToCustomer",
  ];

  const key = findAmountWithPriority(priorityArray, amountObj).keyI;
  const { amount } = findAmountWithPriority(priorityArray, amountObj);

  return { amount, key };
};

export const checkCanMarkAllQuantity = (data) => {
  for (const entry of data) {
    for (const item of entry?.items) {
      const currentState = item?.current_state;
      let conditionMet = true;

      const sumCurrentState = Object.values(currentState).reduce(
        (acc, val) => acc + val,
        0,
      );
      if (item?.can_mark_v2 !== "VIEW_ONLY") {
        conditionMet = item?.is_combo
          ? item?.combo_btn_state === "CHANGE_ISSUES"
          : item?.total_quantity === sumCurrentState;
      }

      if (!conditionMet) {
        return false;
      }
    }
  }
  return true;
};

export const getItemsNotReturnedText = ({ crates, items }) => {
  if (crates && items) {
    return `${crates} ${t(`${RETURN_PATH}/crate`)}, ${items} ${t(
      `${RETURN_PATH}/item`,
    )} ${t(`${RETURN_PATH}/notReturned`)}`;
  } else if (crates) {
    return `${crates} ${t(`${RETURN_PATH}/crate`)} ${t(
      `${RETURN_PATH}/notReturned`,
    )}`;
  } else if (items) {
    return `${items} ${t(`${RETURN_PATH}/item`)} ${t(
      `${RETURN_PATH}/notReturned`,
    )}`;
  }
  return `${t(`${RETURN_PATH}/notReturned`)}`;
};

export const checkIfAllDefective = (data) => {
  for (const section of data) {
    if (section.items && Array.isArray(section.items)) {
      for (const item of section.items) {
        const totalDefectiveItem =
          (item?.current_state?.item_damaged || 0) +
          (item?.current_state?.not_found || 0) +
          (item?.current_state?.wrong_item_received || 0) +
          (item?.current_state?.partial_not_found || 0);
        const totalQuantity = item?.total_quantity || 0;
        if (
          totalDefectiveItem !== totalQuantity &&
          item?.can_mark_v2 !== "VIEW_ONLY"
        ) {
          return false;
        }
      }
    }
  }
  return true;
};

export const checkIfAllDefectiveForTaskPage = (data) => {
  for (const section of data) {
    if (section.items && Array.isArray(section.items)) {
      for (const item of section.items) {
        const totalDefectiveItem =
          (item?.current_state?.item_damaged || 0) +
          (item?.current_state?.not_found || 0) +
          (item?.current_state?.wrong_item_received || 0) +
          (item?.current_state?.partial_not_found || 0);
        const totalQuantity = item?.total_quantity || 0;
        if (
          totalDefectiveItem !== totalQuantity
        ) {
          return false;
        }
      }
    }
  }
  return true;
};
